import React from 'react';
export function Footer() {
  return <footer className="w-full bg-jet-black text-white py-12 px-4" data-id="element-75">
      <div className="max-w-7xl mx-auto" data-id="element-76">
        <div className="flex flex-col items-center text-center space-y-4" data-id="element-77">
          <h3 className="text-2xl font-bold text-white" data-id="element-78">Viridia Analytics</h3>
          <p className="text-gray-400 max-w-lg" data-id="element-79">
            Instant Lead Response Growth Engine for Home Service Contractors
          </p>
          <div className="flex flex-wrap justify-center gap-6 pt-4" data-id="element-80">
            <a href="#privacy" className="text-gray-400 hover:text-viridia-green transition-colors" data-id="element-81">
              Privacy Policy
            </a>
            <a href="#terms" className="text-gray-400 hover:text-viridia-green transition-colors" data-id="element-82">
              Terms of Service
            </a>
            <a href="#contact" className="text-gray-400 hover:text-viridia-green transition-colors" data-id="element-83">
              Contact
            </a>
          </div>
          <p className="text-gray-600 text-sm pt-4" data-id="element-84">
            © {new Date().getFullYear()} Viridia Analytics. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}